import { render, staticRenderFns } from "./SellingServices.vue?vue&type=template&id=b145b5c4&scoped=true&"
import script from "./SellingServices.vue?vue&type=script&lang=js&"
export * from "./SellingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b145b5c4",
  null
  
)

export default component.exports